import dJSON from 'dirty-json';

const moduleSelector = '.detail-cards';

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(query.data);

      data.forEach((item) => {
        query.querySelector('.details-grid').insertAdjacentHTML('beforeend', /* html */ `
          <div class="detail-card">
            ${item.icon ? `<div class="image-wrapper">
              <img src="${item.icon}" alt="${item.title}">
            </div>` : ''}
            <div class="content">
              ${item.title ? `<h2 class="title">${item.title}</h2>` : ''}
              ${item.text ? `<p class="text">${item.text}</p>` : ''}
              ${item.button ? `<a href="${item.link}" class="btn-custom primary">${item.button}</a>` : ''}
            </div>
          </div>
        `);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
